$('body').on('click', '.site-header__nav-toggle', function() {
    $('body').toggleClass('open');
});
